import React, { useState, useEffect } from "react"
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"

import FormSamplePoint from "./FormSamplePoint"
import { withSampleConfig } from "../../../config/SampleConfigProvider"
import { getFormattedMessage } from "../../shared_components_registration"

const ModalSamplePoint = ({ show, onHide, sampling_point, updateMetrics, intl }) => {
  const [samplingPoint, setSamplingPoint] = useState(null)

  useEffect(() => {
    setSamplingPoint(sampling_point)
  }, [sampling_point])

  const init_status = {
    sample_point_update_status: null,
    sample_point_add_status: null,
    sample_point_error: {},
  }

  const hideThis = () => {
    updateMetrics(init_status)
    onHide()
  }

  return (
    <Modal show={show} onHide={hideThis} backdrop={"static"} keyboard={true} className={"overflow-scroll"}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-calendar"} />
          &nbsp;
          {samplingPoint ? (
            <>
              {getFormattedMessage("general.edit", "Edit")}
              :&nbsp;
              {samplingPoint["sample_conn_no"]}
            </>
          ) : (
            <>{getFormattedMessage("general.create", "Create")}</>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormSamplePoint
          sampling_point={samplingPoint}
          init_status={init_status}
          onHide={hideThis}
          intl={intl}
        />
      </Modal.Body>
    </Modal>
  )
}

export default withSampleConfig(ModalSamplePoint)

ModalSamplePoint.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  sampling_point: PropTypes.object,
  updateMetrics: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
}
